import { schema } from 'normalizr';

const pulseSurveyScheduleSchema = new schema.Entity('pulseSurveySchedules', {});

export default pulseSurveyScheduleSchema;
